import React from "react";
import LazyLoad from "react-lazyload";
import Seo from "../components/Seo";
import FinalsHero from "../finals2026-hero.jpg";
import Andrey from "../finalistsheadshot/Andrey.png";
import Vriti from "../finalistsheadshot/Vriti.jpg";
import Kyle from "../finalistsheadshot/Kyle.jpg";
import Zaki from "../finalistsheadshot/Zaki.jpg";
import Aditya from "../finalistsheadshot/Aditya.jpg";
import Malavika from "../finalistsheadshot/Malavika.png";
import Shyntas from "../finalistsheadshot/Shyntas.jpg";
import Dhanvin from "../finalistsheadshot/Dhanvin.png";
import Jeena from "../finalistsheadshot/Jeena.jpg";
import Paulean from "../finalistsheadshot/Paulean.jpg";
import Advika from "../finalistsheadshot/Advika.jpg";

// In-person finals medalists, ordered by placement.
const inPersonFinalists = [
  { id: 1, name: "Andrey Vasilyev", image: Andrey, place: 1, medal: "gold", location: "Florida, USA" },
  { id: 2, name: "Vriti Mirchandani", image: Vriti, place: 2, medal: "silver", location: "Houston, Texas" },
  { id: 3, name: "Kyle Yang", image: Kyle, place: 3, medal: "silver", location: "Carmel, Indiana" },
  { id: 4, name: "Zaki Farhat", image: Zaki, place: 4, medal: "bronze", location: "Charlottesville, Virginia" },
  { id: 5, name: "Aditya Singhal", image: Aditya, place: 5, medal: "bronze", location: "Richmond, Virginia" },
  { id: 6, name: "Malavika Sreehari", image: Malavika, place: 6, medal: "bronze", location: "Indianapolis, Indiana" },
];

// Science Communicator (PSC) Award — top 5, chosen by community vote.
const scienceCommunicators = [
  { id: 1, name: "Kyle Yang", image: Kyle, place: 1 },
  { id: 2, name: "Shyntas Aityk", image: Shyntas, place: 2 },
  { id: 3, name: "Dhanvin Patel", image: Dhanvin, place: 3 },
  { id: 4, name: "Malavika Sreehari", image: Malavika, place: 4 },
  { id: 5, name: "Aditya Singhal", image: Aditya, place: 5 },
];

// Online finalists — top 3.
const onlineFinalists = [
  { id: 1, name: "Jeena Ali", image: Jeena, place: 1 },
  { id: 2, name: "Paulean Amelly Mikowle M. De Guzman", image: Paulean, place: 2 },
  { id: 3, name: "Advika Madhusudan", image: Advika, place: 3 },
];

const MEDAL_COLORS = {
  gold: { bg: "#bb8b1d", soft: "rgba(187, 139, 29, 0.12)" },
  silver: { bg: "#7b8794", soft: "rgba(123, 135, 148, 0.14)" },
  bronze: { bg: "#a9651f", soft: "rgba(169, 101, 31, 0.12)" },
};

const ordinal = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

// Initials fallback for an entrant without a headshot on file.
const initials = (name) =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

const WinnerCard = ({ image, name, place, medal, location }) => {
  const accent = medal ? MEDAL_COLORS[medal].bg : "#004d99";
  const softAccent = medal ? MEDAL_COLORS[medal].soft : "rgba(0, 77, 153, 0.08)";
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.06)",
        border: "1px solid #e8eef3",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 8px 25px rgba(0, 77, 153, 0.1)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.06)";
      }}
    >
      <div
        style={{
          position: "relative",
          paddingTop: "120%",
          backgroundColor: "#f8f9fa",
        }}
      >
        {image ? (
          <LazyLoad once offset={100}>
            <img
              src={image}
              alt={name}
              className="no-invert-image-partners-css"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </LazyLoad>
        ) : (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "linear-gradient(135deg, #e8eef3 0%, #d6e1ec 100%)",
              color: "#004d99",
              fontSize: "2.4rem",
              fontWeight: "700",
              letterSpacing: "0.02em",
            }}
          >
            {initials(name)}
          </div>
        )}
        {place && (
          <span
            style={{
              position: "absolute",
              top: "12px",
              left: "12px",
              padding: "5px 12px",
              borderRadius: "999px",
              backgroundColor: accent,
              color: "#fff",
              fontSize: "0.78rem",
              fontWeight: "700",
              letterSpacing: "0.02em",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.18)",
            }}
          >
            {ordinal(place)} Place
          </span>
        )}
      </div>
      <div style={{ padding: "16px", textAlign: "center" }}>
        {medal && (
          <span
            style={{
              display: "inline-block",
              padding: "3px 10px",
              borderRadius: "6px",
              backgroundColor: softAccent,
              color: accent,
              fontSize: "0.72rem",
              fontWeight: "700",
              textTransform: "uppercase",
              letterSpacing: "0.04em",
              marginBottom: "8px",
            }}
          >
            {medal} Medal
          </span>
        )}
        <h3
          style={{
            fontSize: "0.95rem",
            fontWeight: "600",
            color: "#1a1a2e",
            margin: 0,
          }}
        >
          {name}
        </h3>
        {location && (
          <p
            style={{
              fontSize: "0.82rem",
              color: "#777",
              margin: "4px 0 0 0",
            }}
          >
            {location}
          </p>
        )}
      </div>
    </div>
  );
};

const sectionHeadingStyle = {
  fontSize: "1.5rem",
  fontWeight: "600",
  color: "#1a1a2e",
  marginBottom: "8px",
};

const sectionIntroStyle = {
  fontSize: "0.98rem",
  color: "#555",
  lineHeight: "1.7",
  marginBottom: "24px",
  maxWidth: "760px",
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
  gap: "20px",
};

function FinalResults2026() {
  return (
    <div>
      <Seo
        title="2026 Final Results"
        path="/2026-final-results"
        description="The winners of the 2026 International Research Olympiad — in-person finals medalists, Science Communicator Award winners, and online finalists."
      />
      {/* Header Section */}
      <div style={{ marginBottom: "40px" }}>
        <span
          style={{
            display: "inline-block",
            padding: "6px 14px",
            borderRadius: "6px",
            backgroundColor: "rgba(0, 77, 153, 0.08)",
            color: "#004d99",
            fontSize: "0.85rem",
            fontWeight: "600",
            marginBottom: "16px",
          }}
        >
          June 2026
        </span>
        <h2
          style={{
            fontSize: "2rem",
            fontWeight: "600",
            color: "#1a1a2e",
            marginBottom: "20px",
          }}
        >
          2026 IRO Final Results
        </h2>

        <div
          style={{
            position: "relative",
            width: "100%",
            paddingTop: "60%",
            borderRadius: "16px",
            overflow: "hidden",
            marginBottom: "24px",
            boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
          }}
        >
          <img
            src={FinalsHero}
            alt="2026 IRO International Finals medalists at Harvard Square, Cambridge, MA"
            className="no-invert-image-partners-css"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center 72%",
            }}
          />
        </div>

      </div>

      {/* In-Person Finals */}
      <div style={{ marginBottom: "56px" }}>
        <h3 style={sectionHeadingStyle}>In-Person Finals</h3>
        <p style={sectionIntroStyle}>
          The 2026 International Finals took place from June 19th to June 21st,
          2026 at Harvard Square, Cambridge, MA.
        </p>
        <p style={sectionIntroStyle}>
          The 2026 IRO Finals showcased some of the most promising young minds
          in the world. With its dedication to critical thinking and real-world
          application of knowledge, the IRO is shaping the next generation of
          innovative leaders who will tackle global challenges and make a
          lasting impact on society.
        </p>
        <div style={gridStyle}>
          {inPersonFinalists.map((f) => (
            <WinnerCard
              key={f.id}
              image={f.image}
              name={f.name}
              place={f.place}
              medal={f.medal}
              location={f.location}
            />
          ))}
        </div>
      </div>

      {/* Science Communicator (PSC) Award */}
      <div style={{ marginBottom: "56px" }}>
        <h3 style={sectionHeadingStyle}>Science Communicator Award</h3>
        <p style={sectionIntroStyle}>
          The Science Communicator Award represents the IRO finalists who were
          best able to share their love of science to the world. The winners of
          the Science Communicator Award were chosen by public vote by the IRO
          community.
        </p>
        <div style={gridStyle}>
          {scienceCommunicators.map((f) => (
            <WinnerCard
              key={f.id}
              image={f.image}
              name={f.name}
              place={f.place}
            />
          ))}
        </div>
      </div>

      {/* Online Finalists */}
      <div style={{ marginBottom: "30px" }}>
        <h3 style={sectionHeadingStyle}>Online Finalists</h3>
        <p style={sectionIntroStyle}>
          Competing in the online final round, these finalists distinguished
          themselves among the very best of the 2026 cohort.
        </p>
        <div style={gridStyle}>
          {onlineFinalists.map((f) => (
            <WinnerCard
              key={f.id}
              image={f.image}
              name={f.name}
              place={f.place}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default FinalResults2026;
